import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";
import { listSearch } from "../../../shared/utils/pagination-search";

const searchSchema = listSearch.extend({
  locationId: z.string().optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute("/app/admin/bikes/")({
  validateSearch: searchSchema,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
